import React, { useState } from "react";
import { Box } from "./style";
import returnNumber from "../../lib/returnNumber";

const onlyNumberReg = new RegExp("/^\\d+$/");
export default ({ input, meta, status, label, type, disable, alignLeft, ...others }) => {
  const [focusStatus, setFocusStatus] = useState(false);
  const finalType = type === "currency" ? "text" : type;
  let displayedValue = input.value;
  if (type === "currency") {
    if (!onlyNumberReg.test(input.value)) {
      displayedValue = returnNumber(displayedValue);
    }
    displayedValue =
      displayedValue &&
      displayedValue !== 0 &&
      parseInt(displayedValue).toLocaleString("fa");
  }
  const labelStatus = () => {
    if (input.value && input.value!==0 ) {
      return "top";
    } else {
      return "down";
    }
  };
  const formStatus = () => {
    if (meta.error) {
      return "error";
    }
    return status;
  };
  const notice = () => {
    if (meta.error && meta.error !== "") {
      return <span className="notice">{meta.error}</span>;
    }
  };
  const labelRender = () => {
    if (label && label.length > 0) {
      return (
        <label htmlFor={input.name}>
          <span>{label}</span>
        </label>
      );
    }
  };
  return (
    <Box
      status={status ? status : formStatus()}
      labelStatus={labelStatus()}
      focusStatus={focusStatus}
      alignLeft={alignLeft}
    >
      <input
        id={input.name}
        type={finalType}
        value={displayedValue}
        onChange={e => {
          let returnedValue = e.target.value;
          if (type === "currency") {
            returnedValue = returnNumber(returnedValue);
          }
          input.onChange(returnedValue);
        }}
        onFocus={() => setFocusStatus(true)}
        onBlur={() => setFocusStatus(false)}
        disabled={disable}
        maxLength={input.maxLength}
        {...others}
      />
      {labelRender()}
      {notice()}
    </Box>
  );
};
